import { FileVideoIcon, type Icon } from '@phosphor-icons/react';
import { SecurityCameraIconMirrored } from '@/utils/icons';
import { useFeatureFlags } from '@/hooks';
import { useCameraLimitReached } from '@/features/SettingsView/hooks/useCameraLimitReached';

export type NewSourceOptionKey = 'videoFile' | 'liveCamera';

export interface NewSourceOption {
    key: NewSourceOptionKey;
    icon: Icon;
    labelKey: string;
    enabled: boolean;
    disabled: boolean;
}

export function useNewSourceOptions(): Record<
    NewSourceOptionKey,
    NewSourceOption
> {
    const { videoFilesEnabled, liveCamerasEnabled } = useFeatureFlags();
    const isCameraLimitReached = useCameraLimitReached();

    return {
        videoFile: {
            key: 'videoFile',
            icon: FileVideoIcon,
            labelKey: 'actions.videoFile',
            enabled: videoFilesEnabled,
            disabled: false,
        },
        liveCamera: {
            key: 'liveCamera',
            icon: SecurityCameraIconMirrored,
            labelKey: 'actions.liveCamera',
            enabled: liveCamerasEnabled,
            disabled: isCameraLimitReached,
        },
    };
}
